//Navbar scroll class

(function () {
    "use strict";

    const navbar = document.querySelector(".navbar");
    let lastScroll = 0;
    let ticking = false;

    function onScroll() {
        const scrollTop = window.scrollY;

        if (scrollTop > 10) {
            navbar.classList.add("navbar-scrolled");
        } else {
            navbar.classList.remove("navbar-scrolled");
        }

        ticking = false;
    }

    window.addEventListener("scroll", function () {
        lastScroll = window.scrollY;

        if (!ticking) {
            window.requestAnimationFrame(onScroll);
            ticking = true;
        }
    });
})();